/**
 * useWebSocket Hook - Manages WebSocket connection in React
 */

import { useEffect, useState, useCallback } from 'react';
import websocketService from '../services/websocketService';
import { CONNECTION_STATUS } from '../config/constants';

export const useWebSocket = () => {
  const [status, setStatus] = useState(websocketService.getStatus());
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Connect to WebSocket on mount
    websocketService.connect();

    // Subscribe to status changes
    const unsubscribe = websocketService.onStatusChange((newStatus) => {
      setStatus(newStatus);
      setIsConnected(newStatus === CONNECTION_STATUS.CONNECTED);
    });

    // Set initial status
    setStatus(websocketService.getStatus());
    setIsConnected(websocketService.isConnected());

    // Cleanup on unmount
    return () => {
      unsubscribe();
      // Don't disconnect - keep connection alive for other components
    };
  }, []);

  // Send message function
  const send = useCallback((action, data = {}) => {
    websocketService.send(action, data);
  }, []);

  // Subscribe to message type
  const subscribe = useCallback((type, callback) => {
    return websocketService.subscribe(type, callback);
  }, []);

  return {
    status,
    isConnected,
    send,
    subscribe
  };
};

export default useWebSocket;
